export default {
  onUpdate: registration => {
    // console.log('entreeiaquii999-->');
    registration.unregister().then(() => {
      window.location.reload();
    });
  },
  onSuccess: registration => {
    console.info('service worker on success state');
    // console.log(registration);
  },
};
